import { AggregatedCollection } from './collections/AggregatedCollection';
import { TopicCollection } from './collections/TopicCollection';

const config = require('../config');
const userPreferencesModel = require('./UserPreferences');
const readFilter = require('../readFilter');
const find = require('array-find');

const MAX_SUBSCRIPTIONS_THRESHOLD = config.env.feedTopicMaxSubscriptions;

export class NotificationsModel {
    constructor() {
        const numberOfSubscriptions = userPreferencesModel._countActiveSubscriptions();
        console.log('In constructor');
        this.notifications = [];

        if (numberOfSubscriptions > MAX_SUBSCRIPTIONS_THRESHOLD) {
            this.modelInterface = new AggregatedCollection;
            console.info('Set up model interface', 'AggregatedCollection');
        } else {
            this.modelInterface = new TopicCollection;
            console.info('Set up model interface', 'TopicCollection');
        }

        const pref = userPreferencesModel.get();
        if (pref.preferences) {
            this.lastRead = new Date(pref.preferences.lastRead);
            readFilter.override(pref.preferences.readFilter);
        } else {
            const newDate = new Date();
            newDate.setDate(newDate.getDate() - 5);
            this.lastRead = newDate;
        }

        console.warn('Last read', this.lastRead);
        console.warn('Pref model', pref);
    }

    populateReadStatus(data) {
        data.forEach((notif) => {
            if (!readFilter.contains(notif.id)) {
                if (new Date(this.lastRead) < new Date(notif.creationTimestamp)) {
                    notif.status = 'new';
                } else {
                    notif.status = 'unread';
                }
            } else {
                notif.status = null;
            }
        });

        return data;
    }

    markRead(notif) {
        console.log('Marking read in model', notif);
        console.log('Bloom filter', readFilter.getCleanArray());

        // Update the bloom filter
        readFilter.checkOrAdd(notif.id);
        userPreferencesModel.updateRead();

        console.log('Bloom filter now', readFilter.getCleanArray());

        // Update item
        notif.status = null;  // eslint-disable-line

        return userPreferencesModel.updateRead();
    }

    markAllAsSeen() {
        console.warn('Marking all as seen...');
        this.notifications.forEach((notif) => {
            if (notif.status === 'new') {
                notif.status = 'unread';
            }
        });

        return this.notifications;
    }

    reset() {
        this.notifications = [];
        return this.fetch();
    }

    fetch(loadMore = false) {
        // Fetch notification data from the selected interface
        return this.modelInterface
            .fetch(loadMore)
            .then(({ data, reachedEnd }) => {
                // Sort model data in reverse chronological order
                data.sort((a, b) =>
                        new Date(a.creationTimestamp)
                        >= new Date(b.creationTimestamp) ? 1 : -1);

                const populatedReadData = this.populateReadStatus(data);
                const sortedData = loadMore ? populatedReadData.reverse() : populatedReadData;

                sortedData.forEach((item) => {
                    if (find(this.notifications, i => i.id === item.id)) {
                        return;
                    }

                    this.notifications[loadMore ? 'push' : 'unshift'](item);
                });

                return { notifications: this.notifications, reachedEnd };
            });
    }
}



/** WEBPACK FOOTER **
 ** ./assets/js/models/NotificationsModel.js
 **/